// Stored phones come back as E.164 (+15550001111) while the draft is typed in the
// national format ((555) 000-1111); stored emails keep the author's casing.
export function normalizePhone(value) {
    const digits = String(value).replace(/\D/g, '');
    return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}

export function normalizeEmail(value) {
    return String(value).trim().toLowerCase();
}
